import { AdminHomeHistoryHeaderButtonGroup } from "../button-group/AdminHomeHistoryHeaderButtonGroup";
import { H4 } from "../typography/H4";

interface Props {
  page: number;
  totalPage: number;
  plusPage: () => void;
  minusPage: () => void;
}

export const AdminHomeHistoryHeader: React.FC<Props> = ({
  page,
  totalPage,
  plusPage,
  minusPage,
}) => {
  return (
    <div className="py-[16px]">
      <div className="flex items-center justify-between">
        <div className="flex">
          <H4 className="text-semantic-text-heading">관리자 업데이트</H4>
        </div>
        <AdminHomeHistoryHeaderButtonGroup
          page={page}
          totalPage={totalPage}
          plusPage={plusPage}
          minusPage={minusPage}
        />
      </div>
      <div />
    </div>
  );
};
